import { Component } from '@angular/core';

@Component({
  selector: 'fgb-fantasy-game-rules',
  templateUrl: './fantasy-game-rules.component.html',
  styleUrl: './fantasy-game-rules.component.scss'
})
export class FantasyGameRulesComponent {

}
